module.exports = __webpack_public_path__ + "img/青丘女.7e351454.png";